import { AccountLabel } from "./Account.model";

export enum DraftStatus {
    COMMITTED = "committed",
    IN_PROGRESS = "in_progress",
}

export enum AccountHintType {
    EXISTING = "existing",
    NEW = "new",
}

export type DraftAccountMeta = {
    codatAccountId?: string | null;
    matchMeta?: any | null;
    reason?: string | null;
};

export type DraftAccount = {
    type: AccountHintType;
    accountId?: string | undefined;
    label: AccountLabel;
    accountName: string;
    meta?: DraftAccountMeta | null;
} | null;

export type NewAccount = Pick<
    NonNullable<DraftAccount>,
    "accountName" | "label" | "meta"
>;

export type IdentifierSource = "codat" | "file";

export interface Draft {
    id: string;
    status: DraftStatus;
    fileId: string;
    fileName: string;
    connectorId: string;
    identifierSource: IdentifierSource;
    documentType: string;
    statementType: string;
    companyId: string;
    ownerId: string | null;
    createdAt: string;
    updatedAt: string;
    periods: string[];
    isCodat: boolean;
    isFile: boolean;
    isCleaned: boolean;
    isLabeled: boolean;
    rows: Record<
        string,
        {
            account: DraftAccount;
            rowHeader: string;
            values: Array<{
                period: string;
                value: number;
                identifier: {
                    identifier: string;
                };
                expressions: any[];
            }>;
        }
    >;
}

export interface DraftSnapshot {
    id: string;
    status: DraftStatus;
    fileId: string;
    createdBy: string | null;
    createdAt: string;
    committedAt?: string | null;
}

export enum ValidationFormula {
    COST_OF_GOODS_SOLD = "cost_of_goods_sold",
    TOTAL_OP_EX = "total_operating_expenses",
    EBITDA = "ebitda",
    REVENUE = "revenue",
    CURRENT_ASSETS = "current_assets",
    NONCURRENT_ASSETS = "noncurrent_assets",
    CURRENT_LIABILITIES = "current_liabilities",
    NONCURRENT_LIABILITIES = "noncurrent_liabilities",
    TOTAL_ASSETS = "total_assets",
    TOTAL_LIABILITIES = "total_liabilities",
    TOTAL_EQUITY = "total_equity",
    BALANCE_SHEET_BALANCE = "balance_sheet_balance",
    INCOME_STATEMENT_BALANCE = "income_statement_balance",
}
export interface DraftValidation {
    completeness: {
        status: "warning" | "fail" | "pass" | "loading";
        messages: string[];
    };
    accountNaming: {
        status: "warning" | "fail" | "pass" | "loading";
        messages: Array<{
            rowId: string;
            message: string;
        }>;
    };
    formulas: {
        status: "warning" | "fail" | "pass" | "loading";
        messages: Array<{
            formula: ValidationFormula;
            period: string;
            expected: number;
            actual: number;
            difference: number;
            rows: string[];
            expectedRows: string[];
            detail: string;
        }>;
    };
}

export type DraftRow = Draft["rows"][string];
export type DraftRowEdit = Partial<DraftRow>;
export type DraftEdits = { rows?: Record<string, DraftRowEdit> };
